import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'Home',
    component: ()=>import('@/views/Home')
  },
  {
    path: '/caravana',
    component: ()=>import('@/views/extra/caravana')
  },
  {
    path: '/noticias',
    name: 'Notices',
    component: ()=>import('@/views/NoticesArchive'),
  },
  {
    path: '/noticias/:id',
    props: true,
    name: 'Notice',
    component: ()=>import('@/views/NoticeSingle'),
  },
  {
    path: '/biblioteca',
    name: 'Books',
    component: ()=>import('@/views/BooksArchive')
  },
  {
    path: '/biblioteca/:id',
    props: true,
    name: 'Book',
    component: ()=>import('@/views/BookSingle')
  },
  {
    path: '/publicar-libro',
    name: 'PublishBook',
    meta: {
      requiredAuth: true
    },
    component: ()=>import('@/views/admin/PublishBook')
  },
  {
    path: '/editar/libro/:id',
    props: true,
    name: 'EditBook',
    meta: {
      requiredAuth: true
    },
    component: ()=>import('@/views/admin/EditBook')
  },
  {
    path: '/escuela',
    name: 'School',
    component: ()=>import('@/views/School.vue'),
  },
  {
    path: '/escuela/:id',
    props: true,
    name: 'Technique',
    component: ()=>import('@/views/TechniqueSingle'),
  },
  {
    path: '/contacto',
    name: 'Contact',
    component: ()=>import('@/views/Contact')
  },
  {
    path: '/ingresar',
    name: 'Login',
    meta: {
      requiredGuest: true
    },
    component: ()=>import('@/views/admin/Login')
  },
  {
    path: '/panel',
    name: 'Dashboard',
    meta: {
      requiredAuth: true
    },
    component: ()=>import('@/views/admin/Dashboard')
  },
  {
    path: '/publicar-noticia',
    name: 'Publish',
    meta: {
      requiredAuth: true
    },
    component: ()=>import('@/views/admin/PublishNotice')
  },
  {
    path: '/editar/:id',
    props: true,
    name: 'Edit',
    meta: {
      requiredAuth: true
    },
    component: ()=>import('@/views/admin/EditNotice')
  },
  {
    path: '/mensajes',
    name: 'Messages',
    meta: {
      requiredAuth: true
    },
    component: ()=>import('@/views/admin/Messages')
  },
  {
    path: '/editar/tecnicatura/:id',
    props: true,
    name: 'EditTechnique',
    meta: {
      requiredAuth: true
    },
    component: ()=>import('@/views/admin/EditTechnique')
  },
  {
    path: '/editar-escuela',
    props: true,
    name: 'EditSchool',
    meta: {
      requiredAuth: true
    },
    component: ()=>import('@/views/admin/EditSchool')
  },



  {
    path: '/editar-equipo',
    props: true,
    name: 'EditTeam',
    meta: {
      requiredAuth: true
    },
    component: ()=>import('@/views/admin/EditTeam')
  },
  {
    path: '*',
    redirect: '/'
  },
]

import {auth} from '../firebase'

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition){
    if(savedPosition){
      return savedPosition
    }else{
      return {x: 0, y: 0}
    }
  }
})

router.beforeEach((to, from, next)=>{
  console.log()
  if(to.meta.requiredGuest){
    auth.onAuthStateChanged((user)=>{
      if(user){
        next({name: 'Dashboard'})
      }else{
        next()
      }
    })
  }else if(to.meta.requiredAuth){
    auth.onAuthStateChanged((user)=>{
      if(user){
        next()
      }else{
        next({name: 'Login'})
      }
    })
  }else{
    next()
  }
})

export default router
